import { api } from '@/api/axios-client'
import { AxiosHttpClient } from '@deepcloud/http-client-axios'

export const httpClient = new AxiosHttpClient(api)
